import { render, staticRenderFns } from "./ModalImage.vue?vue&type=template&id=0dc67ec3&scoped=true"
import script from "./ModalImage.vue?vue&type=script&lang=js"
export * from "./ModalImage.vue?vue&type=script&lang=js"
import style0 from "./ModalImage.vue?vue&type=style&index=0&id=0dc67ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc67ec3",
  null
  
)

export default component.exports